<template>
  <div class="footer">
    <div class="footer_content">
      <div class="f_c_img">
        <img :src="SiteLogo.url" class="logImg" style="width:140px;"/>
      </div>
      <div class="f_c_txt">
        대표이사 : {{SiteInfo.ci_boss_name}}  | 사업자등록번호 : {{SiteInfo.ci_business_regi}} | 주소 : {{SiteInfo.ci_addr}} <br>
         {{SiteInfo.ci_tel}} | {{SiteInfo.ci_policy_email}} <br>
        Copyright 2019 {{SiteInfo.ci_name}}, All rights reserved. <br>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
  import util from '@/mixins/util';


  export default {
    name: "PageFooter",
    mixins: [],
    data(){
      return {
          SiteLogo: this.$store.state.common.SiteLogo,
          SiteInfo: this.$store.state.common.SiteInfo,
      }
    },
    created() {
    },
    computed: {
    },
    watch: {
        '$store.state.common.SiteLogo' : {
            deep: true,
            handler(value){
                this.SiteLogo = value;
            },
        },
        '$store.state.common.SiteInfo' : {
            deep: true,
            handler(value){
                this.SiteInfo = value;
            },
        }

    },
    mounted() {
    },
    methods: {
    },
  }
</script>